import React from 'react';

import {
  Button,
  Card,
  CardBody,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import SimpleFooter from './views/examples/components/Footers/SimpleFooter';

const Contact = () => (
  <div className='about' style={{ backgroundColor: 'white', height: '95vh' }}>
    <div className='container' style={{ paddingTop: '70px' }}>
        <br/>
      <h1 className="display-2 text-black" align="center" style={{
        background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
        webkitBackgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        fontSize: '50px'
      }}>Contact Us</h1>
      <section className="section section-lg pt-lg-0 section-contact-us">
            <Container>
              <Row className="justify-content-center mt--300">
                <Col lg="8">
                  <Card className="bg-gradient-secondary shadow">
                    <CardBody className="p-lg-5">
                      <h4 className="mb-1">Interested in a Demo?</h4>
                      <p className="mt-0">
                        Contact us at hello@makeroundtable.com, or fill out the form below, 
                        if you are interested in a product demo, a partnership, or
                        just want to chat!
                      </p>
                      <form action="mailto:hello@makeroundtable.com" onsubmit="return false"
                      method="POST"
                      enctype="multipart/form-data"
                      name="EmailTestForm"> <br/>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-user-run" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Your name"
                            type="text"
                            name="VisitorName"
                            // onFocus={e => this.setState({ nameFocused: true })}
                            // onBlur={e => this.setState({ nameFocused: false })}
                          />
                        </InputGroup> <br/>
                        <Input
                          className="form-control-alternative"
                          cols="80"
                          name="name"
                          placeholder="Type a message..."
                          rows="4"
                          type="textarea"
                          name="VisitorComment"
                        /> <br/><br/>
                        <Button block className="btn-round" size="lg" type="submit">
                          Send Message
                        </Button>
                      </form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
      <br/><br/>
    </div>
  </div>
);

export default Contact;